var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rs-survey-response',{attrs:{"surveyId":_vm.surveyId,"targetKey":_vm.k}})
}
var staticRenderFns = []

export { render, staticRenderFns }